import * as z from 'zod';

import { type ValidationMessageSet } from './form-validations';

export type NameInputs = { firstName: string; lastName: string };

export type NameValidationMessages = Pick<
  ValidationMessageSet,
  'lengthMessage' | 'requiredMessage'
>;

const FIRST_NAME_MAX = 40;
const LAST_NAME_MAX = 80;

export const getNameSchema = (
  firstName: NameValidationMessages,
  lastName: NameValidationMessages
) =>
  z.object({
    firstName: z
      .string({ required_error: firstName.requiredMessage })
      .trim()
      .min(2, firstName.requiredMessage)
      .max(
        FIRST_NAME_MAX,
        firstName.lengthMessage.replace('{max}', String(FIRST_NAME_MAX))
      ),
    lastName: z
      .string({ required_error: lastName.requiredMessage })
      .trim()
      .min(2, lastName.requiredMessage)
      .max(
        LAST_NAME_MAX,
        lastName.lengthMessage.replace('{max}', String(LAST_NAME_MAX))
      ),
  });
